// extracted by mini-css-extract-plugin
export var carrierTab = "_5b-0";
export var carrierTabActive = "_5b-1 _5b-0";
export var carrierTabInactive = "_5b-2 _5b-0";
export var carrierTabLabel = "_5b-3";
export var carrierTabLabelActive = "_5b-4 _5b-3";
export var carrierTabLabelInactive = "_5b-5 _5b-3";
export var carrierTabPercentage = "_5b-6";
export var carrierTabPercentageActive = "_5b-7 _5b-6";
export var carrierTabPercentageInactive = "_5b-8 _5b-6";
export var carrierTabWinnable = "_5b-9";
export var carrierTabWinnableActive = "_5b-a _5b-9";
export var carrierTabWinnableInactive = "_5b-b _5b-9";
export var comparisonContainer = "_5b-d";
export var missingRateButton = "_5b-n";
export var missingRateButtonActive = "_5b-o _5b-n";
export var missingRateButtonInactive = "_5b-p _5b-n";
export var missingRateButtonLabel = "_5b-q";
export var missingRateButtonLabelActive = "_5b-r _5b-q";
export var missingRateButtonLabelInactive = "_5b-s _5b-q";
export var sidebar = "_5b-c";
export var strategyButton = "_5b-e";
export var strategyButtonActive = "_5b-f _5b-e";
export var strategyButtonDescription = "_5b-k";
export var strategyButtonDescriptionActive = "_5b-l _5b-k";
export var strategyButtonDescriptionInactive = "_5b-m _5b-k";
export var strategyButtonInactive = "_5b-g _5b-e";
export var strategyButtonLabel = "_5b-h";
export var strategyButtonLabelActive = "_5b-i _5b-h";
export var strategyButtonLabelInactive = "_5b-j _5b-h";
export var unitToggleButton = "_5b-t";
export var unitToggleButtonActive = "_5b-u _5b-t";
export var unitToggleButtonInactive = "_5b-v _5b-t";
export var unitToggleButtonLabel = "_5b-w";
export var unitToggleButtonLabelActive = "_5b-x _5b-w";
export var unitToggleButtonLabelInactive = "_5b-y _5b-w";